import React from "react";
import { Box, Typography } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import { Divider } from "@mui/material";
import { IMAGE_URL } from "config";

const data = [
  {
    image: "/images/iMac Memoji2.svg",
    title: "Chef Juna Food",
    rating: "4.7",
    review: " ( 150 Reviews )",
  },
];

const AboutMeal = ({ menu, caterer }) => {
  return (
    <Box>
      <Box>
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: { lg: "row", md: "row", sm: "row", xs: "column" },
            alignItems: { lg: "start", md: "start", sm: "start", xs: "center" },
            // border:"1px solid red"
          }}
        >
          <Box sx={{ width: { lg: "30%", md: "30%", sm: "30%", xs: "100%" } }}>
            <>
              <Box component="container">
                <Box
                  sx={{
                    width: "100%",
                    height: "auto",
                    display: "flex",
                    flexDirection: "column",
                    gap: "16px",
                    pt: "12px",
                    pl: "14px",
                  }}
                >
                  <Box sx={{ width: "96px", height: "96px" }}>
                    <img src={IMAGE_URL + caterer?.image} alt="" width="100%" />
                  </Box>

                  <Box>
                    <Box>
                      <Typography
                        sx={{
                          fontSize: "24px",
                          fontWeight: "600",
                        }}
                      >
                        {caterer?.merchantName}
                      </Typography>
                    </Box>

                    <Box
                      sx={{
                        display: "flex",
                        flexDirection: "row",
                        width: "100%",
                      }}
                    >
                      <Box
                        sx={{
                          width: "auto",
                          height: "12.45px",
                          pr: "10px",
                        }}
                      >
                        <StarIcon width="100%" sx={{ color: "#FAA641" }} />
                      </Box>
                      <Box>
                        <Typography
                          sx={{
                            fontSize: "14px",
                            fontWeight: "600",
                            pt: "2px",
                            pl: "5px",
                            color: "#FAA641",
                          }}
                        >
                          {caterer?.rating}
                        </Typography>
                      </Box>
                      <Box>
                        <Typography sx={{ color: "#9EA3AE" }}>
                          {caterer?.review}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Box>
              </Box>
            </>
          </Box>
          <Box sx={{ width: { lg: "69%", md: "69%", sm: "69%", xs: "100%" } }}>
            <Box sx={{ ml: "0px" }}>
              <Box>
                <Typography
                  sx={{
                    fontWeight: 600,
                    fontSize: "27px",
                  }}
                >
                  About this menu
                </Typography>
                <Typography
                  sx={{
                    mt: "20px",
                    color: "#545359",
                  }}
                >
                  {menu?.description}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
      <Divider sx={{ mt: "30px", mb: "30px" }} />
    </Box>
  );
};

export default AboutMeal;
